module.exports = __webpack_public_path__ + "static/img/6.9b4084ae.png";